import { Button, DialogContent, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { ModalComponent } from 'app/shared-components/modals/modalManager';

export type NorthAcceptOptionsDialogResult = 'CALL_NOW' | 'SUBMIT_APPLICATION';

export const NorthAcceptOptionsDialog: ModalComponent<
  void,
  NorthAcceptOptionsDialogResult | undefined
> = ({ open, onClose }) => (
  <AppSimpleDialog
    open={open}
    handleClose={() => onClose(undefined)}
    title="Choose how to proceed"
    size="sm"
  >
    <Divider />
    <DialogContent className="px-24 flex flex-col items-center">
      <div className="my-16 flex flex-col gap-16 w-full">
        <Button
          onClick={() => onClose('CALL_NOW')}
          className="rounded-full bg-green-500 px-14 hover:bg-green-600 text-white"
        >
          Call the processor now
        </Button>
        <Button
          onClick={() => onClose('SUBMIT_APPLICATION')}
          className="rounded-full bg-blue-primary px-14 hover:bg-blue-primary-hover text-white"
        >
          Submit my Application here
        </Button>
      </div>
    </DialogContent>
  </AppSimpleDialog>
);
